export default __webpack_public_path__ + "static/media/lock.e16a2324.png";